import { UserAgent, Inviter } from 'sip.js';
import { SessionState } from 'sip.js/lib/core';

const onMakeCall = async(userAgent, userURI, setupRemoteMedia, cleanupMedia, outgoingCall, outgoingCallAccepted, handleCloseDialPad, endOutgoing)=>{
    try{
        userAgent.start().then(() => {
            const target = UserAgent.makeURI(userURI);//sip:bob@example.com
            const inviter = new Inviter(userAgent, target);
            handleCloseDialPad();
            inviter.stateChange.addListener((state) => {
              switch (state) {
                case SessionState.Initial:
                  outgoingCall(inviter)
                  break;
                case 'Establishing':
                  outgoingCall(inviter)
                  setupRemoteMedia(inviter);
                  break;
                case 'Established':
                  outgoingCallAccepted();
                  break;
                case 'Terminating':
                  // fall through
                case SessionState.Terminated:
                case 'Terminated':
                  cleanupMedia();
                  endOutgoing();
                  break;
                default:
                  console.log("Unknown session state.");
              }
            });

            inviter.invite();
        });
    }catch (error) {
        console.log('Error to call', error);
    }
}

const onEndCall = async(session, end, cleanupMedia)=>{
    try{
        switch(session.state) {
            case SessionState.Initial:
            case 'Establishing':
              if (session instanceof Inviter) {
                // An unestablished outgoing session
                session.cancel();
              } else {
                // An unestablished incoming session
                session.reject();
              }
              break;
            case 'Established':
              // An established session
              session.bye();
              break;
            case 'Terminating':
            case SessionState.Terminated:
            case 'Terminated':
              cleanupMedia()
              // Cannot terminate a session that is already terminated
              break;
          }
          end();
    }catch (error) {
        console.log('Error to end/reject call', error);
    }
}

export { onMakeCall, onEndCall};